import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import routes from "routes.js";
import { BackgroundColorContext } from "contexts/BackgroundColorContext";

function Offer(props) {
  const mainPanelRef = React.useRef(null);

  const getRoutes = (routesList) => {
    return routesList.map((prop, key) => {
      if (prop.layout === "/offer") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      }
      return null;
    });
  };

  return (
    <BackgroundColorContext.Consumer>
      {({ color }) => (
        <div className="wrapper">
          <div className="main-panel" ref={mainPanelRef} data={color}>
            <Switch>
              {getRoutes(routes)}
              <Redirect from="*" to="/offer/landing" />
            </Switch>
          </div>
        </div>
      )}
    </BackgroundColorContext.Consumer>
  );
}

export default Offer;